import { render, staticRenderFns } from "./CyberpunkBox.vue?vue&type=template&id=46484672&scoped=true&"
import script from "./CyberpunkBox.vue?vue&type=script&lang=js&"
export * from "./CyberpunkBox.vue?vue&type=script&lang=js&"
import style0 from "./CyberpunkBox.vue?vue&type=style&index=0&id=46484672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46484672",
  null
  
)

export default component.exports